const translations = {
  english: {
    heading: "Welcome!",
    intro:
      "ATKV members whose membership is up to date, qualify for member rates (discount) at our resorts. To find out if you qualify, enter your SA ID number here and click on “Confirm”.",
    unsure:
      "1) Use the main member's ID number.<br>      2) If your correct ID number is not on our system, the verification may fail. <br>      3) Members without a SA ID, must use their passport number, if it is on our system. <br>       For any enquiries, please contact our client service team on 011 919 9000. If you are not an ATKV member, and want to know how you can benefit from membership, like among others discount at our resorts, click <a href='https://atkv.org.za/sluit-aan/'>here.</a>",
    switchLabel: "Change language using this switch",
    checkStatusButton: "Confirm",
    inputPlaceholder: "Enter SA ID Number here...",
  },
  afrikaans: {
    heading: "Welkom!",
    intro:
      "ATKV-lede wie se lidmaatskap op datum is, kwalifiseer vir lidtariewe (afslag) by ons oorde. Om te bepaal of u kwalifiseer, tik u SA ID-nommer hier in en klik op “Bevestig”.",
    unsure:
      "1) Gebruik die hooflid se ID-nommer.<br> 2) Indien u korrekte ID-nommer nie op ons stelsel is nie, kan die verifiëring misluk.<br>      3) Lede wat nie ŉ SA ID het nie, moet hulle paspoortnommer gebruik, indien dit op ons stelsel is. <br>      Vir enige navrae, kontak asseblief ons kliëntediens by 011 919 9000. Indien u nie ŉ ATKV-lid is nie, en wil uitvind hoe u by lidmaatskap kan baat vind, soos onder andere afslag by ons oorde, klik <a href='https://atkv.org.za/sluit-aan/'>hier</a>. <br>",
    switchLabel: "Verander taal deur hierdie skakelaar",
    checkStatusButton: "Bevestig",
    inputPlaceholder: "SA ID Nommer kom hier...",
  },
};

export default translations;
